module.exports = __webpack_public_path__ + "static/media/icon-hourglass-light.88734f0c.svg";